import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Button from './../Button/Button';
import InputSearch from './../InputSearch/InputSearch';
import NotesListItem from './../NotesListItem/NotesListItem';
import { deleteNote, createNote, setEditedNoteId } from '../../notesSlice';
import SpriteEl from '../SpriteEl/SpriteEl';

function NotesList() {
	const { notes } = useSelector(state => state.notes);
	const addNoteButtonDisabledClass = useSelector(state => state.notes.addNoteButtonDisabledClass);

	const dispatch = useDispatch();

	const [searchText, setSearchText] = useState("");
	const [filteredNotes, setFilteredNotes] = useState([]);
	const [noteExists, setNoteExists] = useState(false);

	useEffect(() => {
		if (!notes || typeof notes !== 'object' || Object.keys(notes).length === 0) return;

		const searchLowerCase = searchText.toLowerCase();

		const filtered = Object.values(notes).filter((note) => {
			if (!note) return false; // Ensure the note exists

			const title = note.post_title ? note.post_title.toLowerCase() : "";
			const content = note.note ? note.note.toLowerCase() : "";

			return title.includes(searchLowerCase) || content.includes(searchLowerCase);
		});

		setFilteredNotes(filtered);

		const currentPageUrl = window.location.href;
		setNoteExists(Object.values(notes).some(note => note.post_url === currentPageUrl));
	}, [searchText, notes]);

	const addNoteHandler = (e) => {
		e.stopPropagation();
		dispatch(createNote());
	}

	const updateNoteHandler = (e, noteId) => {
		e.stopPropagation();
		dispatch(setEditedNoteId(noteId));
	}

	const deleteNoteHandler = (noteId) => {
		dispatch(deleteNote(noteId));
	}

	return (
		!notes || notes.length === 0 ? (
			<div className="notes__block notes__block--main">
				<div className="notes-preview">
					<div className="notes-preview__icon">
						<SpriteEl id="create-rounded" />
					</div>
					<div className="notes-preview__title">
						Пока нет заметок
					</div>
					<div className="notes-preview__subtitle">
						Давайте добавим первую?
					</div>
				</div>
				<div className="notes__button">
					<Button
						tag="button"
						size="md"
						color="black"
						title="Добавить заметку"
						onclick={(e) => addNoteHandler(e)}
						disabled={'disabled' === addNoteButtonDisabledClass}
					/>
				</div>
			</div>
		) : (
			<div className="notes__block notes__block--list-notes">
				<div className="notes-list">
					<div className="notes-list__seacrh">
						<InputSearch
							placeholder="Слово или фраза заметки"
							value={searchText}
							ariaLabelSearch="Поиск"
							ariaLabelClear="Очистить"
							onChange={(e) => setSearchText(e.target.value)}
						/>
					</div>
					{filteredNotes.length === 0 ? (
						<div className="notes-preview">
							<div className="notes-preview__subtitle">
								Заметок не найдено
							</div>
						</div >
					) : (
						<div className="notes-list__items">
							{filteredNotes.map((note, index) => {
								const dateObj = new Date(note.datetime * 1000);
								const formattedDate = dateObj.toLocaleDateString('ru-RU');
								const formattedTime = dateObj.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', hour12: false });

								return (
									<NotesListItem
										key={index}
										noteId={note.note_id}
										title={note.post_title}
										url={note.post_url}
										text={note.note}
										infoName={note.post_title}
										date={formattedDate}
										time={formattedTime}
										onclick={(e) => updateNoteHandler(e, note.note_id)}
										onDelete={() => deleteNoteHandler(note.note_id)}
									/>
								);
							})}
						</div>
					)}
					<div className="notes__button">
						<Button
							tag="button"
							size="md"
							color="black"
							title="Добавить заметку"
							onclick={addNoteHandler}
							disabled={'disabled' === addNoteButtonDisabledClass || noteExists}
						/>
					</div>
				</div >
			</div>
		)
	);
}
export default NotesList;